module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraBlack.815d772a.woff";